import { Agent } from "https";

import fetch from "node-fetch";
import pLimit, { Limit } from "p-limit";

import { createWebPackDevServerWorker } from "./WebpackDevServerWorker/WebpackDevServerWorkerFactory";

export class ClientJsDevServer {
    private readonly port: number;
    private readonly engineDirectory: string;
    private readonly startParallelLimit: Limit;
    private started = false;
    private readonly buildDebugOnly: boolean;
    private readonly httpsAgent = new Agent({ rejectUnauthorized: false, keepAlive: true });

    public constructor(port: number, engineDirectory: string, buildDebugOnly: boolean) {
        this.port = port;
        this.engineDirectory = engineDirectory;
        this.startParallelLimit = pLimit(1);
        this.buildDebugOnly = buildDebugOnly;
    }

    public async start(): Promise<void> {
        return this.startParallelLimit(async () => {
            if (this.started) {
                return;
            }
            await createWebPackDevServerWorker(this.engineDirectory, "clientjs.webpack.config.js", this.port, {
                resourcesPath: "dist",
                outputFilename: "client",
                development: "true",
                production: this.buildDebugOnly ? "false" : "true",
                sourceMapPrefix: "static/",
            });
            this.started = true;
        });
    }

    public async getClientJsContentAsStream(minified: boolean): Promise<NodeJS.ReadableStream> {
        const fileName = minified ? "client.min.js" : "client.js";
        return this.getFileStream(`static/public/scripts/${fileName}`);
    }

    public async getFileStream(filePathUrl: string): Promise<NodeJS.ReadableStream> {
        const request = await fetch(`https://localhost:${this.port}/${filePathUrl}`, {
            method: "GET",
            agent: this.httpsAgent,
        });
        return request.body;
    }
}
